module.exports = __webpack_public_path__ + "assets/assets/images/info/american-association-of-endodontists.bb147f72.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/info/american-association-of-endodontists.svg
// module id = 222
// module chunks = 0